// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"j4-z"};